import React from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import PressHero from '../../components/PressAndNews/PressHero'
import AdvertisementsSection from '../../components/PressAndNews/AdvertisementsSection'
import SustainabilityPartnershipBanner from '../../components/PressAndNews/SustainabilityPartnershipBanner'
import ArticlesAndEventsGrid from '../../components/PressAndNews/ArticlesAndEventsGrid'
import { useEffect } from 'react'
function PressAndNews() {
  useEffect(() => {
    window.scrollTo(0, 0);

  }, [])
  return (
    <>
    <Header/>
<>
  <div className="ml-4 sm:ml-8 md:ml-16 lg:ml-32 xl:ml-72 pr-4 sm:pr-8 xl:pr-0 text-[26px] sm:text-[32px] md:text-[40px] xl:text-[48px] font-bold pt-12 sm:pt-16 lg:pt-20 xl:pt-24">
    <span className="text-[#0D924F]">Press & </span>News
  </div>

  <div className="ml-4 sm:ml-8 md:ml-16 lg:ml-32 xl:ml-72 pr-4 sm:pr-8 xl:pr-0 text-[15px] sm:text-[16px] xl:text-[18px] font-normal mb-10 sm:mb-14 xl:mb-20 text-[#898989]">
    Explore the latest news, media coverage, and partner advertisements driving sustainability forward.
  </div>
</>
    <PressHero/>
    <AdvertisementsSection/>
    <SustainabilityPartnershipBanner/>
    <ArticlesAndEventsGrid/>
    <Footer/>
    </>
  )
}

export default PressAndNews